module.exports = __webpack_public_path__ + "img/fennec.61f62315.jpg";